/**
 * @prettier
 */

export function isOffline(): boolean {
    if (!navigator) return false;
    return !navigator.onLine;
}
